export const answers = {
  spools: ["0", "1", "2", "3 to 5", "more than 5"],
  preps: ["Yes", "No"],
  binary: ["Yes", "No"],
  binary0: ["Yes", "No"],
  binary1: ["Yes", "No"],
  constructions: [
    "Before 1970",
    "1970 to 1984",
    "1985 to 1999",
    "After 2000",
    "Unknown year of construction"
  ],
  upgrades: [
    "No upgrade",
    "Before 1970",
    "1970 to 1984",
    "1985 to 1999",
    "After 2000",
    "Unknown date of upgrade"
  ],
  regions: ["A", "B", "C", "D"],
  distances: [
    "Less than 100 m",
    "100 to 200 m",
    "200 to 500 m",
    "More than 500 m"
  ],
  areas: [
    "less than 100 m square",
    "100 m2 to 200 m square",
    "200 m2 to 500 m square",
    "500m2 to 1000 m square",
    "1000 m2 to 2000 m square",
    "greater than 2000 m square"
  ],
  hvacs: [
    "No centralised HVAC",
    "Basement",
    "Ground level external to the building",
    "Ground level within the building",
    "Mounted on the roof",
    "Inside on upper floors"
  ],
  floors: [
    "Carpet",
    "Timber",
    "Material other than those listed",
    "Lino or vinyl",
    "Tiles",
    "Concrete"
  ]
};
